/* BROHN SMITH lead tracking
   Tells Google Analytics and Meta when Shopify has accepted an enquiry.
   Works beside the Klaviyo hand-off in theme.js and follows the same rule:
   the form submits natively, and the event fires on the page we land on
   once Shopify has accepted it.
   Only the kind of enquiry and the piece are sent. No name, email, phone
   or message leaves the page from here. */
(function () {
  'use strict';

  var KEY = 'bs_lead_pending';

  function bind() {
    var forms = document.querySelectorAll('.enquiry-form');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.hasAttribute('data-lead-bound')) return;
      form.setAttribute('data-lead-bound', '');
      form.addEventListener('submit', function () {
        try {
          var pieceEl = form.querySelector('[data-enq-piece]');
          var piece = pieceEl ? pieceEl.value : '';
          var appointment = /appointment/i.test(piece) || /\/pages\/appointment/.test(window.location.pathname);
          sessionStorage.setItem(KEY, JSON.stringify({
            type: appointment ? 'appointment' : 'product_enquiry',
            piece: piece
          }));
        } catch (err) { /* tracking must never cost us the enquiry */ }
      });
    });
  }

  function report() {
    var lead;
    try {
      var posted = /contact_posted=true/.test(window.location.search) || !!document.querySelector('.enquiry-form__success');
      if (!posted) return;
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      sessionStorage.removeItem(KEY);
      lead = JSON.parse(raw);
    } catch (err) { return; }
    if (!lead) return;

    /* The Google and Meta tags load after the page, so wait for each one
       (up to about fifteen seconds) and send to each exactly once. */
    var sentGoogle = false, sentMeta = false, tries = 0;
    (function attempt() {
      try {
        if (!sentGoogle && typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', { lead_type: lead.type, piece: lead.piece });
          sentGoogle = true;
        }
        if (!sentMeta && typeof window.fbq === 'function') {
          window.fbq('track', 'Lead', { content_category: lead.type, content_name: lead.piece });
          sentMeta = true;
        }
      } catch (err) { /* never let tracking break the page */ }
      tries += 1;
      if ((!sentGoogle || !sentMeta) && tries < 30) window.setTimeout(attempt, 500);
    })();
  }

  function init() {
    try { bind(); } catch (err) { /* leave the form alone */ }
    try { report(); } catch (err) { /* leave the page alone */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { try { bind(); } catch (err) {} });
})();
